import { Preference, Token, User } from "./types"

export enum UserAction {
  SET_INITIALIZATION = 'SET_USER_INITIALIZATION',
  LOG_OUT_USER = 'LOG_OUT_USER',
  SET_TOKENS = 'SET_TOKENS',
  SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN',
  SET_USER = 'SET_USER',
  SET_LANGUAGE = 'SET_LANGUAGE',
  UPDATE_PREFERENCES = 'UPDATE_PREFERENCES'
}

export const removeUser = () => ({
  type: UserAction.LOG_OUT_USER,
  data: undefined
})

export const updateTokens = (data: Token) => ({
  type: UserAction.SET_TOKENS,
  data
})

export const updateAccessToken = (token: string) => ({
  type: UserAction.SET_ACCESS_TOKEN,
  data: token
})

export const setUser = (data: User) => ({
  type: UserAction.SET_USER,
  data
})

export const setUserInitialization = (data: boolean) => ({
  type: UserAction.SET_INITIALIZATION,
  data
})

export const setLanguageCode = (data: string) => ({
  type: UserAction.SET_LANGUAGE,
  data
})

export const updateUserPreferences = (data: Partial<Preference>) => ({
  type: UserAction.UPDATE_PREFERENCES,
  data
})
